export default __webpack_public_path__ + "static/media/pic3.d6e06a46.jpg";